import React, { useEffect, useState } from 'react' 
import Main from '../../cpn/Main'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Button, Space, Steps } from 'antd'
import { ArrowLeftOutlined, BlockOutlined, ApartmentOutlined } from '@ant-design/icons'
import { useYhUpdateQuery } from '../../store/BnsKeJiApi'
import ModuleEdit from '../module/ModuleEdit'
import SketchAdd from '../sketch/SketchAdd'
import RateAdd from '../rate/RateAdd'
import SketchEdit from '../sketch/SketchEdit'
import RateEdit from '../rate/RateEdit'

function ClientDesc() {
    const [param] = useSearchParams()
    const navigate = useNavigate()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const yh_id = param.get('yh_id')
    const yh_name = param.get('yh_name')
    const {data,isSuccess} = useYhUpdateQuery({yh_id:yh_id},{skip:!yh_id})
    const [info,setInfo] = useState({
        yh_content:'',
        children: []
    })
    const [currentYh, setCurrentYh] = useState(null)

    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                setInfo({
                    yh_content:data.Result.yh_content,
                    yh_name:data.Result.yh_name,
                    yh_dept_id:data.Result.yh_dept_id,
                    yh_dept_name:data.Result.yh_dept_name,
                    yh_ctime:data.Result.yh_ctime,
                    yh_cname:data.Result.yh_cname,
                    yh_num:data.Result.yh_num,
                    children:data.Result.children || [],
                })
            }
        }
    },[data,isSuccess])

    useEffect(() => {
        if(info.children && Array.isArray(info.children) && info.children.length > 0) {
            setCurrentYh(info)
        }
    }, [info])

    const handleBack = () => {
        navigate(`/project/desc?yh_id=${yh_id}`)
    }

    // 处理图片点击放大
    const handleImageClick = (e) => {
        const target = e.target;
        if (target.tagName === 'IMG') {
            const src = target.src;
            const alt = target.alt || '';
            
            // 创建全屏预览
            const overlay = document.createElement('div');
            overlay.style.cssText = `
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.8);
                z-index: 9999;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            `;
            
            const img = document.createElement('img');
            img.src = src;
            img.alt = alt;
            img.style.cssText = `
                max-width: 90%;
                max-height: 90%;
                object-fit: contain;
                border-radius: 8px;
                box-shadow: 0 4px 20px rgba(0,0,0,0.5);
                transition: transform 0.3s ease;
                cursor: zoom-in;
            `;
            
            // 缩放相关变量
            let scale = 1;
            let isDragging = false;
            let startX = 0;
            let startY = 0;
            let translateX = 0;
            let translateY = 0;
            
            // 更新图片变换
            const updateTransform = () => {
                img.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
            };
            
            // 鼠标滚轮缩放
            const handleWheel = (e) => {
                e.preventDefault();
                const delta = e.deltaY > 0 ? 0.9 : 1.1;
                const newScale = scale * delta;
                
                // 限制缩放范围
                if (newScale >= 0.1 && newScale <= 5) {
                    scale = newScale;
                    updateTransform();
                    
                    // 更新鼠标指针
                    img.style.cursor = scale > 1 ? 'zoom-out' : 'zoom-in';
                }
            };
            
            // 鼠标拖拽
            const handleMouseDown = (e) => {
                if (scale > 1) {
                    isDragging = true;
                    startX = e.clientX - translateX;
                    startY = e.clientY - translateY;
                    img.style.cursor = 'grabbing';
                }
            };
            
            const handleMouseMove = (e) => {
                if (isDragging) {
                    translateX = e.clientX - startX;
                    translateY = e.clientY - startY;
                    updateTransform();
                }
            };
            
            const handleMouseUp = () => {
                isDragging = false;
                img.style.cursor = scale > 1 ? 'zoom-out' : 'zoom-in';
            };
            
            // 双击重置
            const handleDoubleClick = () => {
                scale = 1;
                translateX = 0;
                translateY = 0;
                updateTransform();
                img.style.cursor = 'zoom-in';
            };
            
            // 添加事件监听器
            img.addEventListener('wheel', handleWheel);
            img.addEventListener('mousedown', handleMouseDown);
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            img.addEventListener('dblclick', handleDoubleClick);
            
            // 阻止图片点击事件冒泡
            img.addEventListener('click', (e) => {
                e.stopPropagation();
            });
            
            overlay.appendChild(img);
            document.body.appendChild(overlay);
            
            // 点击关闭
            overlay.addEventListener('click', () => {
                // 清理事件监听器
                img.removeEventListener('wheel', handleWheel);
                img.removeEventListener('mousedown', handleMouseDown);
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                img.removeEventListener('dblclick', handleDoubleClick);
                document.removeEventListener('keydown', handleKeyPress);
                
                document.body.removeChild(overlay);
            });
            
            // ESC键关闭
            const handleKeyPress = (e) => {
                if (e.key === 'Escape') {
                    // 清理事件监听器
                    img.removeEventListener('wheel', handleWheel);
                    img.removeEventListener('mousedown', handleMouseDown);
                    document.removeEventListener('mousemove', handleMouseMove);
                    document.removeEventListener('mouseup', handleMouseUp);
                    img.removeEventListener('dblclick', handleDoubleClick);
                    document.removeEventListener('keydown', handleKeyPress);
                    
                    document.body.removeChild(overlay);
                }
            };
            document.addEventListener('keydown', handleKeyPress);
        }
    }

    if (!currentYh) {
        return (
            <Main>
                <div style={{maxWidth:"1280px",backgroundColor:'#fff',padding:'20px',borderRadius:'10px'}}>
                    <div style={{textAlign:'center',padding:'50px'}}>
                        <div>加载中...</div>
                    </div>
                </div>
            </Main>
        )
    }

    return (
        <Main>
            <style>
                {`
                    .clickable-image img {
                        cursor: pointer !important;
                        border: 2px solid transparent !important;
                        border-radius: 4px !important;
                        transition: border-color 0.3s ease !important;
                    }
                    .clickable-image img:hover {
                        border-color: #1890ff !important;
                    }
                `}
            </style>
            <div style={{maxWidth:"1280px",backgroundColor:'#fff',padding:'20px',borderRadius:'10px'}}>
                {/* 头部信息 */}
                <div style={{marginBottom:'20px'}}>
                    <Button 
                        type="primary" 
                        icon={<ArrowLeftOutlined />} 
                        onClick={handleBack}
                        style={{marginBottom:'15px'}}
                    >
                        返回项目详情
                    </Button>
                    <h1 style={{textAlign:'center',margin:'0'}}>{info.yh_name}</h1>
                    <div style={{textAlign:'center',color:'#666',marginTop:'10px'}}>
                        {info.yh_ctime} {info.yh_cname}
                    </div>
                    <div 
                        className="clickable-image"
                        dangerouslySetInnerHTML={{__html:currentYh.yh_content}}
                        onClick={handleImageClick}
                    ></div>
                </div>
                {/* 模块列表 */}
                {currentYh.children && Array.isArray(currentYh.children) && currentYh.children.map((module,index_bxmxq)=>(
                    <div key={index_bxmxq} style={{marginBottom:'30px'}}>
                        <div style={{display:'flex',alignItems:'center',marginBottom:'15px',padding:'15px',}}>
                            <BlockOutlined style={{marginRight:'10px',color:'#52c41a',fontSize:'20px'}} />
                            <div>
                                <Space style={{fontSize:'20px',fontWeight:'bold',color:'#52c41a'}}>
                                    模块 <span style={{color:'#000000'}}>{index_bxmxq + 1} - {module.bxmxq_name}</span> 
                                    <Space style={{fontSize:'12px',color:'#999',fontWeight:'normal'}}>
                                        <ModuleEdit 
                                            bxmxq_id={module.bxmxq_id} 
                                            bxm_id={module.bxmxq_bxm_id} 
                                            bxm_name={module.bxmxq_bxm_name} 
                                            eu_id={eu_id} 
                                            eu_name={eu_name}
                                        />
                                        <SketchAdd 
                                            eu_id={eu_id} 
                                            eu_name={eu_name} 
                                            bxm_id={module.bxmxq_bxm_id} 
                                            bxm_name={module.bxmxq_bxm_name} 
                                            yh_id={yh_id} 
                                            yh_name={module.bxmxq_name}
                                            bxmxq_id={module.bxmxq_id}
                                            bxmxq_name={module.bxmxq_name}
                                        />
                                    </Space>
                                </Space>
                            </div>
                        </div>
                        <div 
                            className="clickable-image"
                            dangerouslySetInnerHTML={{__html:module.bxmxq_content}}
                            style={{marginLeft:'30px',marginBottom:'20px'}}
                            onClick={handleImageClick}
                        ></div>
                        
                        {/* 流程列表 */}
                        {module.children && Array.isArray(module.children) && module.children.map((process,index_bxmbb)=>(
                            <div key={index_bxmbb} style={{marginLeft:'20px',marginBottom:'25px'}}>
                                <div style={{display:'flex',alignItems:'center',marginBottom:'10px',padding:'12px'}}>
                                    <ApartmentOutlined style={{marginRight:'8px',color:'#fa8c16',fontSize:'16px'}} />
                                    <div>
                                        <Space style={{fontSize:'16px',fontWeight:'bold',color:'#fa8c16'}}>
                                            流程 <span style={{color:'#000000'}}>{index_bxmxq + 1}-{index_bxmbb + 1} - {process.bxmbb_name}</span>
                                            <Space style={{fontSize:'12px',color:'#999',fontWeight:'normal'}}>
                                                <SketchEdit
                                                    bxmxq_id={module.bxmxq_id} 
                                                    bxmxq_name={module.bxmxq_name}
                                                    bxm_id={module.bxmxq_bxm_id} 
                                                    bxm_name={module.bxmxq_bxm_name} 
                                                    eu_id={eu_id} 
                                                    eu_name={eu_name}
                                                    bxmbb_id={process.bxmbb_id}
                                                    bxmbb_name={process.bxmbb_name}
                                                />
                                                <RateAdd 
                                                    eu_id={eu_id} 
                                                    eu_name={eu_name} 
                                                    bxm_id={module.bxmxq_bxm_id} 
                                                    bxm_name={module.bxmxq_bxm_name} 
                                                    bxmxq_id={module.bxmxq_id} 
                                                    bxmxq_name={module.bxmxq_name}
                                                    yh_id={yh_id} 
                                                    yh_name={yh_name}
                                                />
                                            </Space>
                                        </Space>
                                    </div>
                                </div>
                                <div 
                                    className="clickable-image"
                                    dangerouslySetInnerHTML={{__html:process.bxmbb_content}}
                                    style={{marginLeft:'30px',marginBottom:'15px'}}
                                    onClick={handleImageClick}
                                ></div>
                                
                                {/* 界面列表 */}
                                {/* {process.children && Array.isArray(process.children) && process.children.map((interface_item,index_pf)=>(
                                    <div key={index_pf} style={{marginLeft:'20px',marginBottom:'15px'}}>
                                        <div style={{display:'flex',alignItems:'center',marginBottom:'8px',padding:'10px'}}>
                                            <EyeOutlined style={{marginRight:'6px',color:'#722ed1',fontSize:'14px'}} />
                                            <div>
                                                <Space style={{fontSize:'14px',fontWeight:'bold',color:'#722ed1'}}>
                                                    界面 <span style={{color:'#000000'}}>{index_bxmxq + 1}-{index_bxmbb + 1}-{index_pf + 1} - {interface_item.pf_name}</span>
                                                </Space>
                                                <Space style={{fontSize:'12px',color:'#999',fontWeight:'normal'}}>
                                                    <RateEdit
                                                        pf_id={interface_item.pf_id}
                                                        pf_name={interface_item.pf_name}
                                                        pf_content={interface_item.pf_content}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                        <div dangerouslySetInnerHTML={{__html:interface_item.pf_content}} style={{marginLeft:'30px'}}></div>
                                    </div>
                                ))} */}
                                 <Steps
                                     direction="vertical"
                                     current={1}
                                       items={process.children?.map((interface_item, index_pf) => ({
                                           title: <>{interface_item.pf_name} <RateEdit pf_id={interface_item.pf_id} pf_name={interface_item.pf_name} pf_content={interface_item.pf_content}/></>,
                                           description: (
                                               <div 
                                                   className="clickable-image"
                                                   dangerouslySetInnerHTML={{__html:interface_item.pf_content}}
                                                   style={{marginLeft:'30px',maxWidth:"1100px"}}
                                                   onClick={handleImageClick}
                                               />
                                           ),
                                           key: interface_item.pf_id || index_pf,
                                           icon: <span style={{fontSize:'14px',fontWeight:'bold'}}>{index_pf + 1}</span>
                                       })) || []}
                                     style={{marginLeft:'30px'}}
                                 />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </Main>
    )
}

export default ClientDesc
